<template>
  <div class="w-full">
    <section class="p-12 space-y-8">
      <header class="space-y-2">
        <BaseButton small primary outline @click="$emit('back')">Back</BaseButton>
        <h3 class="text-lg font-medium">Create new project</h3>
      </header>
      <div>
        <BaseFetchData :action="fetchData">
          <template #default="fetchDataProps">
            <div v-if="fetchDataProps.status.resolved" class="space-y-6">
              <BaseFormTextFieldWithValidator v-model="projectData.name" v-bind="nameFieldProps" />
              <BaseFormSelectFieldWithValidator
                v-model="projectData.ownerUserId"
                v-bind="ownerFieldProps"
              />
            </div>
          </template>
        </BaseFetchData>
      </div>
      <BaseVeeForm :action="submit">
        <!-- formProps
          isIdle, isPending, isResolved, isRejected, invalid
          errors, submit, hasServerErrors, getServerErrorMessages
        -->
        <template #default="formProps">
          <div
            v-if="formProps.hasServerErrors"
            class="rounded-md bg-red-50 p-4 text-sm text-red-700 mb-8"
          >
            <ul role="list" class="list-disc space-y-1 pl-5">
              <li v-for="(msg, msgIdx) in formProps.getServerErrorMessages()" :key="msgIdx">
                {{ msg }}
              </li>
            </ul>
          </div>
          <BaseButton primary :disabled="formProps.isPending || formProps.invalid"
            >Create and Select project</BaseButton
          >
        </template>
      </BaseVeeForm>
    </section>
  </div>
</template>

<script>
import { accountMembersClient, accountProjectsClient } from '@/api/clients';
import BaseFormSelectFieldWithValidator from '@/components/BaseFormSelectFieldWithValidator.vue';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    customerAccountId: {
      type: String,
      required: true,
    },
    defaultProjectData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      memberOptions: [],
      projectData: {
        name: '',
        ownerUserId: null,
      },
    };
  },
  created() {
    this.projectData.name = this.defaultProjectData?.name || '';
  },
  computed: {
    nameFieldProps() {
      return {
        validator: {
          name: 'name',
          vid: 'name',
          rules: { required: true },
        },
        field: {
          id: 'project_name',
          label: 'Project name',
        },
      };
    },
    ownerFieldProps() {
      return {
        validator: {
          name: 'owner',
          vid: 'ownerUserId',
          rules: { required: true },
        },
        field: {
          options: this.memberOptions,
          id: 'project_owner_user_id',
          label: 'Project owner',
        },
      };
    },
  },
  methods: {
    fetchData() {
      return accountMembersClient.list(this.accountId).then((response) => {
        this.memberOptions = response.data.data.map((user) => ({
          value: user.id,
          label: user.fullName,
        }));
      });
    },
    submit() {
      return accountProjectsClient
        .store(this.accountId, {
          ...this.projectData,
          customerId: this.customerAccountId,
        })
        .then((r) => {
          this.$emit('select', r.data.uuid);
        });
    },
  },
  components: { BaseFormSelectFieldWithValidator },
};
</script>
